/** @format */

import {styled} from '@mui/material/styles';
import {ExpandLess, MoreHoriz} from '@mui/icons-material';
import {Box} from '@mui/material';

const baseIconStyle = (theme: any) => ({
  fontSize: '16px',
  color: theme.palette.figma_gray_light_1?.main,
});

export const StyledExpandLess = styled(ExpandLess)(({theme}) => ({
  ...baseIconStyle(theme),
}));

export const StyledMoreHoriz = styled(MoreHoriz)(({theme}) => ({
  ...baseIconStyle(theme),
}));

export const ExpandIndicatorContainer = styled(Box)(({theme}) => ({
  display: 'flex',
  justifyContent: 'center',
  marginTop: theme.spacing(1),
}));
